// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ISetupStepProps } from ".";
import { filter, pipe } from "callbag-basics";
import subscribe from "callbag-subscribe";
import { useCallback, useEffect, useRef, useState } from "react";
import * as React from "react";
import { useSelector } from "react-redux";

import { Loader } from "@livechat/design-system";

import { ButtonGroup } from "components/button/ButtonGroup";
import { config } from "config/config";
import { LOCAL_STORAGE_SAVED_DOMAIN_KEY } from "constants/settings";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { removeItem } from "services/local-storage";
import { actions$ } from "store/action-stream";
import { RequestAction } from "store/entities/actions";
import {
  EmailDomainActionsNames,
  IEmailDomainUnverified,
  selectEmailDomainLoading,
} from "store/entities/email-domains";

import { DomainSetupActionType, NewDomainAction } from "../DomainSetupModal";

import {
  DNSSetupDomainHeader,
  RecordConfigurationDetails,
  RecordConfigurationDomainConnect,
  RecordConfigurationManualProvider,
} from "./components";
import { LoaderWrapper, SetupNameContainer, StyledButton } from "./styles";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const onCreateFailed = (fn: (ICreateEmailDomainFailurePayload: any) => void) =>
  pipe(
    actions$,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filter((action: any) => action.type === EmailDomainActionsNames.CREATE[RequestAction.FAILURE]),
    subscribe(fn)
  );

export const SetupCNameRecords: React.FC<ISetupStepProps<NewDomainAction>> = ({
  modalAction,
  licenseId,
  domains,
  onConfigurationStringCopy,
  createCustomDomain,
  setModalAction,
  manualFlowRef,
  initialFlow,
  setInitialFlow,
}) => {
  const targetDomain = domains.find(
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(18048)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (domain: any) => domain?.name?.toLowerCase() === modalAction?.domainName.toLowerCase()
  );
  const [failedDomain, setFailedDomain] = useState(null);
  const [validationError, setValidationError] = useState<{ error: string; type: string }>({ error: "", type: "" });
  const [loading, setLoading] = useState(false);
  const popupRef = useRef(null);
  const createFailedRef = useRef<boolean | null>(null);
  const { domainName } = modalAction;
  const disableButton = validationError.type === "conflict" || validationError.type === "limitExceeded";
  const timerRef = useRef(null);
  const isEmailDomainLoading = useSelector(selectEmailDomainLoading);

  useEffect(() => {
    // @ts-expect-error TS(2345)
    createCustomDomain(modalAction.domainName, true);

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      // @ts-expect-error TS(2769): No overload matches this call.
      clearInterval(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (targetDomain?.status === "pendingConfiguration") {
      // @ts-expect-error TS(2322)
      setModalAction({ type: DomainSetupActionType.FinishSetup, domainId: targetDomain.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDomain]);

  useEffect(() => {
    const unsubscribe = onCreateFailed(action => {
      const {
        errorObject: { details, type },
      } = action.payload;

      setFailedDomain({ ...details, id: modalAction.domainName });
      setInitialFlow(details?.dcSyncURL ? "domainConnect" : "manualProvider");
      setLoading(false);

      switch (type) {
        case "conflict":
          setValidationError({
            error: "This domain name is already used. Please choose another domain name.",
            type: "conflict",
          });
          trackEngagement("Domains: Domain already used on other license", EventPlace.Settings);
          break;
        case "limitExceeded":
          setValidationError({
            error: "Domain number limit is reached.",
            type: "limitExceeded",
          });
          trackEngagement("Domains: Limit of domains exceeded", EventPlace.Settings);
          break;
        default:
          break;
      }

      if (!createFailedRef.current) {
        createFailedRef.current = true;
      } else {
        switch (type) {
          case "conflict":
            setValidationError({
              error: "This domain name is already used. Please choose another domain name.",
              type: "conflict",
            });
            trackEngagement("Domains: Domain already used on other license", EventPlace.Settings);
            break;
          case "limitExceeded":
            setValidationError({
              error: "Domain number limit is reached.",
              type: "limitExceeded",
            });
            trackEngagement("Domains: Limit of domains exceeded", EventPlace.Settings);
            break;
          default:
            setValidationError({ error: "We couldn't verify ownership.", type: "default" });
            trackEngagement("Domains: Domain failed to be verified", EventPlace.Settings);
            break;
        }
      }
    });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleContinue = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      event.preventDefault();
      removeItem(LOCAL_STORAGE_SAVED_DOMAIN_KEY);
      setLoading(true);

      if (!targetDomain?.domain) {
        // @ts-expect-error TS(2345)
        createCustomDomain(targetDomain?.id);
      } else {
        // @ts-expect-error TS(2322)
        setModalAction({ type: DomainSetupActionType.FinishSetup, domainId: targetDomain.id });
      }
    },
    [createCustomDomain, setModalAction, targetDomain]
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpenPopup = () => {
    // @ts-expect-error TS(2322): Type 'Window | null' is not assignable to type 'nu... Remove this comment to see the full error message
    popupRef.current = window.open(
      // @ts-expect-error TS(2339): Property 'dcSyncURL' does not exist on type 'never... Remove this comment to see the full error message
      `${failedDomain?.dcSyncURL}`,
      "popup",
      "width=600,height=600,scrollbars=no,resizable=no"
    );

    trackEngagement("Domains: Open DomainConnect popup", EventPlace.Settings);
    setLoading(true);

    // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'null'.
    timerRef.current = setInterval(() => {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      if (popupRef.current.closed) {
        // @ts-expect-error TS(2769): No overload matches this call.
        clearInterval(timerRef.current);
        setLoading(false);

        // @ts-expect-error TS(18048)
        if (!targetDomain.domain) {
          // @ts-expect-error TS(18048)
          createCustomDomain(targetDomain.id);
        } else {
          // @ts-expect-error TS(2322)
          setModalAction({ type: DomainSetupActionType.FinishSetup, domainId: targetDomain.id });
        }
      }
    }, 1000);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleManualSwitch = () => {
    setInitialFlow("manualProvider");
    setValidationError({ error: "", type: "" });
    trackEngagement("Domains: Switch flow to manual from DomainConnect", EventPlace.Settings);
    // eslint-disable-next-line no-param-reassign
    manualFlowRef.current = true;
  };

  if (!failedDomain) {
    return (
      <>
        <DNSSetupDomainHeader text="Domain name" domainName={domainName} />

        <LoaderWrapper>
          <Loader size="large" />
        </LoaderWrapper>
      </>
    );
  }

  return (
    <>
      <DNSSetupDomainHeader text="Domain name" domainName={domainName} />
      {(manualFlowRef.current || initialFlow === "manualProvider") && (
        <SetupNameContainer>
          <RecordConfigurationDetails>
            <RecordConfigurationManualProvider
              recordType="CNAME"
              value="helpdesk.com"
              hostname={`${config.customDomainCNamePrefix}${licenseId}.${domainName}`}
              onCopy={onConfigurationStringCopy}
              targetDomain={failedDomain as IEmailDomainUnverified}
              validationError={validationError}
              // @ts-expect-error TS(2322)
              domainName={domainName}
            />
            <ButtonGroup>
              <StyledButton
                size="compact"
                kind="primary"
                onClick={handleContinue}
                loading={loading || isEmailDomainLoading}
                disabled={disableButton}
              >
                Verify and continue
              </StyledButton>
            </ButtonGroup>
          </RecordConfigurationDetails>
        </SetupNameContainer>
      )}

      {!manualFlowRef.current && initialFlow === "domainConnect" && (
        <SetupNameContainer>
          <RecordConfigurationDetails>
            <RecordConfigurationDomainConnect
              handleChangeSetup={handleManualSwitch}
              onPopupClick={handleOpenPopup}
              validationError={validationError}
              targetDomain={failedDomain as IEmailDomainUnverified}
              loading={loading || isEmailDomainLoading}
            />
          </RecordConfigurationDetails>
        </SetupNameContainer>
      )}
    </>
  );
};
